// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-catalog__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 18px 24px 24px 0;
	gap: 24px;
}

.dashboard-catalog__content {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 12px;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
}

.dashboard-catalog__content-filters {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
}

.dashboard-catalog__title {
	font-size: 20px;
	line-height: 25px;
	font-weight: 500;
	color: #191919;
}

.dashboard-catalog__content-products {
	display: grid;
	align-items: start;
	padding: 24px;
	border-radius: 10px;
	background-color: white;
}

.dashboard-catalog__content-products-list {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 24px;
}

.dashboard-catalog__content-filters-wrapper {
	display: flex;
	align-items: center;
	gap: 16px;
}

.dashboard-catalog-button {
	background-color: transparent !important;
	color: #1c6fd1 !important;
	border: 1px solid rgba(28, 111, 209, 0.5) !important;
}

.dashboard-header-dwopdown-item {
	color: #1c6fd1 !important;
}

.catalog-dashboard-title-block {
	color: #1a4074;
	text-align: center;
	font-size: 1.6rem;
}

.dashboard-catalog-checkbox input {
	background-color: transparent;
	border: 2px solid rgb(255 250 250);
}

.dashboard-catalog__tiktok-verified {
	position: absolute;
	top: 8px;
	left: 8px;
	width: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/DashboardCatalog/DashboardCatalog.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,4DAA4D;CAC5D,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB,oDAAoD;AACrD;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;CAC7B,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;AACZ","sourcesContent":[".dashboard-catalog__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 18px 24px 24px 0;\n\tgap: 24px;\n}\n\n.dashboard-catalog__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 12px;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n}\n\n.dashboard-catalog__content-filters {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 24px;\n}\n\n.dashboard-catalog__title {\n\tfont-size: 20px;\n\tline-height: 25px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.dashboard-catalog__content-products {\n\tdisplay: grid;\n\talign-items: start;\n\tpadding: 24px;\n\tborder-radius: 10px;\n\tbackground-color: white;\n}\n\n.dashboard-catalog__content-products-list {\n\twidth: 100%;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n\tgap: 24px;\n}\n\n.dashboard-catalog__content-filters-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.dashboard-catalog-button {\n\tbackground-color: transparent !important;\n\tcolor: #1c6fd1 !important;\n\tborder: 1px solid rgba(28, 111, 209, 0.5) !important;\n}\n\n.dashboard-header-dwopdown-item {\n\tcolor: #1c6fd1 !important;\n}\n\n.catalog-dashboard-title-block {\n\tcolor: #1a4074;\n\ttext-align: center;\n\tfont-size: 1.6rem;\n}\n\n.dashboard-catalog-checkbox input {\n\tbackground-color: transparent;\n\tborder: 2px solid rgb(255 250 250);\n}\n\n.dashboard-catalog__tiktok-verified {\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 8px;\n\twidth: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
